var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"box":"","rules":_vm.rulesName,"label":_vm.labelName,"counter":"","maxlength":_vm.maxlength,"autofocus":_vm.autofocus},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721d4042","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/NameTextField.vue
// module id = null
// module chunks = 